var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.625,
    height: 31.5,
    viewBox: "0 0 23.625 31.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.014,17.6a37.851,37.851,0,0,1-3.859,6.044,62,62,0,0,1-4.343,5.06,61.979,61.979,0,0,1-4.343-5.06A37.85,37.85,0,0,1,5.611,17.6a13.621,13.621,0,0,1-1.642-5.788,9.844,9.844,0,0,1,19.688,0A13.65,13.65,0,0,1,22.014,17.6Zm-8.2,13.9S25.625,20.306,25.625,11.813A11.813,11.813,0,1,0,2,11.813C2,20.306,13.813,31.5,13.813,31.5Z",
    transform: "translate(-2)",
    fill: "#21a7d0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.906,12.844a3.938,3.938,0,1,1,3.938-3.937A3.937,3.937,0,0,1,10.906,12.844Zm0,1.969A5.906,5.906,0,1,0,5,8.906,5.906,5.906,0,0,0,10.906,14.813Z",
    transform: "translate(0.906 2.906)",
    fill: "#21a7d0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.2a6dd740ad7ce165bc54cbae23163369.svg";
export { ForwardRef as ReactComponent };